export enum APIErrorCodes {
    Forbidden = 'FORBIDDEN',
    NotFound = 'NOT_FOUND',
    NotAllowed = 'METHOD_NOT_ALLOWED',
    BadRequest = 'BAD_REQUEST',
    ValidationError = 'VALIDATION_ERROR',
    AlreadyExists = 'ALREADY_EXISTS',

    PageNotFound = 'PAGE_NOT_FOUND',

    StorageUploadError = 'STORAGE_UPLOAD_ERROR',
    UploadSessionFileSizeLimit = 'UPLOAD_SESSION_FILE_SIZE_LIMIT',
    UploadSessionInProgressError = 'UPLOAD_SESSION_IN_PROGRESS_ERROR',
    UploadSessionLimitExceeded = 'UPLOAD_SESSION_LIMIT_EXCEEDED',
    UploadSessionNotFound = 'UPLOAD_SESSION_NOT_FOUND',
    InvalidUploadSession = 'INVALID_UPLOAD_SESSION',
    MalformedUploadSessionRequest = 'MALFORMED_UPLOAD_REQUEST',

    CommentingDisabled = 'COMMENTING_IS_DISABLED',
    ParentCommentNotFound = 'PARENT_COMMENT_NOT_FOUND',

    FeatureNotImplemented = 'NOT_IMPLEMENTED',
    QuotaExceeded = 'QUOTA_EXCEEDED',
    EmptyCustomAcl = 'EMPTY_CUSTOM_ACL',

    NotMs365Page = 'NOT_MS365_PAGE',

    SlugOccupied = 'SLUG_OCCUPIED',
    SlugReserved = 'SLUG_RESERVED',

    BookmarkNotFound = 'BOOKMARK_NOT_FOUND',
    BookmarkLimitExceeded = 'BOOKMARK_LIMIT_EXCEEDED',

    TagLimitExceeded = 'TAG_LIMIT_EXCEEDED',
    TagNotFound = 'TAG_NOT_FOUND',

    Tvm2Only = 'TVM2_ONLY',
    TVM2TicketRequired = 'TVM2_TICKET_REQUIRED',

    PageReserved = 'PAGE_IS_RESERVED',

    RedirectChain = 'REDIRECT_CHAIN',

    InvalidStatusTransition = 'INVALID_STATUS_TRANSITION',

    UserFeatureIsProcessing = 'USER_FEATURE_IS_PROCESSING',

    NoOrganization = 'NO_ORGANIZATION',

    ParamsNeeded = 'PARAMS_NEEDED',

    // server errors
    InternalServerError = 'INTERNAL_SERVER_ERROR',
    NinjaApiError = 'API_ERROR',
}
